import { Controller } from 'stimulus'
import isMobile from './utils'

class MapBaseController extends Controller {
  initialize () {
    L.mapbox.accessToken =
      'pk.eyJ1IjoidGhlZmxvb3ciLCJhIjoiaGFWLVhLRSJ9.X1fJCnMuqwE9wzFiitHiUw'
    this.zoom = 18
    this.animationDuration = 0
    this.map = null
    this.mapPoints = []
  }

  disconnect () {
    this.destroy()
  }

  showLoader () {
    $(this.element).parent().find('.trip-map__loading').show()
  }

  hideLoader () {
    $(this.element)
      .parent()
      .find('.trip-map__loading')
      .fadeOut('fast', function () {
        $(this).hide()
      })

    this.update()
  }

  update () {
    if (!this.map) {
      return
    }

    this.fitInBounds()
  }

  destroy () {
    if (!this.map) {
      return
    }

    this.showLoader()
    this.map.remove()
    this.map = null
  }

  addControls (interactive = false) {
    if (interactive) {
      if (!isMobile()) {
        new L.Control.Zoom({ position: 'bottomleft' }).addTo(this.map)
      }
    } else {
      this.map.dragging.disable()
      this.map.touchZoom.disable()
      this.map.doubleClickZoom.disable()
    }

    // Since we have the attribution info button inside a wrapper that contains a link,
    // we want to prevent the click event from navigating to somewhere else
    // preserving the external child links functionality
    $('.leaflet-compact-attribution').click(function (event) {
      const senderElementName = event.target.tagName.toLowerCase()
      if (senderElementName === 'div') {
        event.preventDefault()
      }
    })
  }

  fitInBounds () {
    this.map.invalidateSize()
    this.map.fitBounds(this.getLatLng(), { padding: [20, 20] })
  }

  centerOnCoordinate (coordinates, zoom = this.zoom) {
    this.map.setView(coordinates, zoom)
  }

  getLatLng () {
    let e, n
    for (e = [], n = 0; n < this.mapPoints.length; n++) {
      e.push([this.mapPoints[n].lat, this.mapPoints[n].lon])
    }

    return e
  }
}

export default MapBaseController
